import { useMemo } from 'react';

import {
  useSalonsCategoriesListQuery,
  useSalonsRetrieveQuery,
  useServicesPublicSalonListQuery,
} from '../../../services/GLOWClient';
import { buildSalonTemplateViewModel } from '../salonPublicTemplates/salonTemplateViewModel';


const getOpeningHours = (salon) => (
  salon?.opening_hours
  ?? salon?.openingHours
  ?? salon?.hours
  ?? salon?.schedule
  ?? salon?.horaires
  ?? salon?.opening_hours_text
  ?? salon?.openingHoursText
  ?? null
);

const isLoadingCurrentData = (query) => Boolean(
  query.isLoading || (query.isFetching && query.currentData === undefined)
);

const useSalonThemePreviewData = (salonId, language) => {
  const parsedSalonId = Number.parseInt(String(salonId), 10) || 0;
  const skip = !parsedSalonId;
  const salonQuery = useSalonsRetrieveQuery(
    { salonId: parsedSalonId, language },
    { skip },
  ) || {};
  const categoriesQuery = useSalonsCategoriesListQuery(
    { salonId: parsedSalonId },
    { skip },
  ) || {};
  const servicesQuery = useServicesPublicSalonListQuery(
    { salonId: parsedSalonId },
    { skip },
  ) || {};
  const salonData = salonQuery.currentData;
  const categoriesData = categoriesQuery.currentData;
  const servicesData = servicesQuery.currentData;
  const salonLoading = isLoadingCurrentData(salonQuery);
  const categoriesLoading = isLoadingCurrentData(categoriesQuery);
  const servicesLoading = isLoadingCurrentData(servicesQuery);
  const isLoading = Boolean(
    salonLoading || categoriesLoading || servicesLoading
  );
  const isError = Boolean(
    salonQuery.isError
    || categoriesQuery.isError
    || servicesQuery.isError
  );

  const viewModel = useMemo(() => {
    const normalized = buildSalonTemplateViewModel({
      salon: salonData,
      categories: categoriesData,
      services: servicesData,
      promotions: [],
      team: salonData?.employees,
      reviews: [],
      openingHours: getOpeningHours(salonData),
      closures: [],
      language,
      canClientBook: true,
      isFavorite: false,
    });

    return {
      ...normalized,
      publicState: {
        isAuthenticated: false,
        reviewsLoading: false,
        reviewsError: null,
        servicesLoading: Boolean(categoriesLoading || servicesLoading),
        promoBanner: null,
        photoIndex: 0,
      },
    };
  }, [
    categoriesData,
    categoriesLoading,
    language,
    salonData,
    servicesData,
    servicesLoading,
  ]);

  return { viewModel, isLoading, isError };
};

export default useSalonThemePreviewData;
